(function () {
  function initLightboxNav(modal) {
    if (modal.dataset.navReady) return;
    const content = modal.querySelector('.product-media-modal__content');
    const dialog = modal.querySelector('.product-media-modal__dialog');
    if (!content || !dialog) return;

    modal.dataset.navReady = 'true';

    const isControl = (el) =>
      el.classList.contains('lightbox-nav') ||
      el.classList.contains('product-media-modal__toggle');

    const getItems = () =>
      Array.from(content.children).filter((el) => !isControl(el));

    // Déplace le X dans le cadre de l'image
    const toggle = modal.querySelector('.product-media-modal__toggle');
    if (toggle) content.append(toggle);

    // Clic ou tap à l'extérieur de l'image = fermer (même effet que le X)
    dialog.addEventListener('click', (e) => {
      if (!e.target.closest('.product-media-modal__content')) {
        if (typeof modal.hide === 'function') {
          modal.hide();
        } else if (toggle) {
          toggle.click();
        }
      }
    });

    // Navigation seulement s'il y a plus d'un média
    if (getItems().length < 2) return;

    // Intercepte le clic souris sur les flèches AVANT l'écouteur de Dawn
    modal.addEventListener(
      'pointerup',
      (e) => {
        if (e.target.closest('.lightbox-nav')) e.stopPropagation();
      },
      true
    );

    const show = (delta) => {
      const items = getItems();
      let idx = items.findIndex((el) => el.classList.contains('active'));
      if (idx < 0) idx = 0;
      items[idx].classList.remove('active');
      idx = (idx + delta + items.length) % items.length;
      items[idx].classList.add('active');
    };

    const makeBtn = (dir, label, symbol) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'lightbox-nav lightbox-nav--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = symbol;

      ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchend'].forEach((evt) => {
        b.addEventListener(evt, (e) => e.stopPropagation());
      });

      b.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        show(dir === 'prev' ? -1 : 1);
      });
      return b;
    };

    content.append(
      makeBtn('prev', 'Image précédente', '&#10094;'),
      makeBtn('next', 'Image suivante', '&#10095;')
    );

    // Flèches du clavier (grand écran)
    document.addEventListener('keyup', (e) => {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') show(-1);
      if (e.key === 'ArrowRight') show(1);
    });

    // Glissement du doigt (mobile)
    let startX = null;
    content.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
    content.addEventListener(
      'touchend',
      (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) show(dx > 0 ? -1 : 1);
        startX = null;
      },
      { passive: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-modal').forEach(initLightboxNav);
  });
})();

